import gql from 'graphql-tag'

export const fetchRecommendedListQuery = gql`
query ($shipTo: String, $selectedItem: String, $cartItems: [CartItemsInput]) {
  recommendItems(
    shipTo: $shipTo
    selectedItem: $selectedItem
    cartItems: $cartItems
  ) {
    shipTo
    recItems {
      productId
      Priority
      multi_deposit
      name
      material_type
      number_of_items_in_box
      your_price
      your_price_tax
      favourites
      product_last
      product_new
      product_sale
      product_recommended
      productId
      number_of_products_on_layer
      number_of_items_on_pallet
      number_of_layers_per_pallet
      isavailable_truck_package_ordering
      small_image
      multi_deposit_z099
      redemption_fee
      pack_format
      tags {
        value
        label
        color
      }
      cart_fields {
        packaging_cart
        layer_cart
        pallets_cart
      }
      __typename
    }
  }
}
`
